import { compress } from "micro-graphql-react"

export default compress`
  mutation(
    $id: ID!
  ) {
    rejectTutorSubject(
      id: $id
    ) {
      tutorSubject {
        id
        approvalState
      }
    }
  }
`
